import { call, put, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import queryString from 'query-string';
import clone from 'ramda/src/clone';
import split from 'ramda/src/split';
import startsWith from 'ramda/src/startsWith';
import propEq from 'ramda/src/propEq';
import find from 'ramda/src/find';
import findIndex from 'ramda/src/findIndex';
import { AppActions, CommunityActions, CompanyActions } from '~/actions';
import { history } from '~/reducers';
import decamelize from '~/services/decamelize';
import NavigationService from '~/services/NavigationService';

export function* addforumtopicRequest(api, action) {
    try {
        const { payload, after, callback } = action;
        const response = yield api.postForumTopic(payload);
        if (response.ok) {
            toast.success(`Forum ${payload.topic.id ? `Edited` : `Created`} Successfully`, {
                position: toast.POSITION.CENTRE_RIGHT,
            });
            if (after) yield put({ ...after });
            if (callback) yield callback();
            const responseForum = yield api.getForumRecentTopic(1, 10);
            yield call(NavigationService.push, '/forums');
            yield put(CommunityActions.addforumtopicSuccess(responseForum));
            yield put(CompanyActions.getblogcategoriesRequest());
        } else {
            yield put(CommunityActions.addforumtopicFailure());
        }
    } catch (e) {
        yield put(CommunityActions.addforumtopicFailure());
    }
}

export function* postcreateblogRequest(api, action) {
    try {
        const { payload, after, callback } = action;
        const response = yield api.postCreateBlog(payload);
        if (response.ok) {
            if (after) yield put({ ...after });
            if (callback) callback(response.data);
            yield put(CommunityActions.postcreateblogSuccess());
        } else {
            yield put(CommunityActions.postcreateblogFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postcreateblogFailure());
    }
}

export function* getforumindividualtopicRequest(api, action) {
    try {
        const { payload, route } = action;
        const options = queryString.stringify(payload, { arrayFormat: 'bracket' });
        const response = yield api.getGetTopics(options);
        if (response.ok) {
            yield put(CommunityActions.getforumindividualtopicSuccess(response.data));
            if (route) yield call(NavigationService.push, route);
        } else {
            yield put(CommunityActions.getforumindividualtopicFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getforumindividualtopicFailure());
    }
}

export function* addtopiccommentRequest(api, action) {
    try {
        const { payload, callback } = action;
        const response = yield api.postSaveComment(payload);
        if (response.ok) {
            if (callback) yield callback();
            yield put(CommunityActions.addtopiccommentSuccess(response.data));
        } else {
            yield put(CommunityActions.addtopiccommentFailure());
        }
    } catch (e) {
        yield put(CommunityActions.addtopiccommentFailure());
    }
}

export function* editforumtopicRequest(api, action) {
    try {
        const {
            payload: { data, pagination },
        } = action;
        const response = yield api.postSaveComment(data);
        if (response.ok) {
            const responseForum = yield api.getForumRecentTopic(pagination.page, pagination.perPage);
            yield put(CommunityActions.editforumtopicSuccess(responseForum));
        } else {
            yield put(CommunityActions.editforumtopicFailure());
        }
    } catch (e) {
        yield put(CommunityActions.editforumtopicFailure());
    }
}

export function* postsavecommentRequest(api, action) {
    try {
        const { payload, callback } = action;
        const response = yield api.postSaveComment(payload);
        if (response.ok) {
            toast.success(`Comment successfully`, { position: toast.POSITION.TOP_RIGHT });
            yield put(CommunityActions.postsavecommentSuccess(response.data));
            if (payload.userId) {
                const communityBlogs = yield select((state) => state.community.communityBlogs);
                const blog = clone(find(propEq('user_id', payload?.userId), communityBlogs));
                const idx = findIndex(propEq('id', response.data.comment[0].parent_id), blog?.posts?.data);
                if (idx > -1) {
                    blog.posts.data[idx].comments.push(response.data.comment[0]);
                    yield put(CommunityActions.getcommunityblogSuccess(blog));
                }
            }
            if (callback) yield callback();
        } else {
            yield put(CommunityActions.postsavecommentFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postsavecommentFailure());
    }
}

export function* postcontentflagRequest(api, action) {
    try {
        const user = yield select((state) => state.app.user?.community_user);
        const liked = { user_id: user.id, name: `${user.first_name} ${user.last_name}` };

        const { payload, route, after, callback } = action;
        const { contentId, flag } = payload;
        const response = yield api.postFlagContent(contentId, flag);
        if (response.ok) {
            if (flag === 'spam') {
                toast.success(response.data.message ?? "We've received your report, and will take appropriate action after review.", {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                yield put(CommunityActions.postcontentflagFailure());
            } else {
                yield put(CommunityActions.postcontentflagSuccess({ ...payload, liked }));
            }
            if (after) yield put({ ...after });
            if (callback) yield callback();
            if (route) yield call(NavigationService.push, route);
        } else {
            yield put(CommunityActions.postcontentflagFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postcontentflagFailure());
    }
}

export function* addcontenteventRequest(api, action) {
    try {
        const { data, after, route, callback } = action.payload;
        const response = yield api.postContentEvent(data);
        if (response.ok) {
            yield put(CommunityActions.addcontenteventSuccess());
            if (after) yield put({ ...after });
            if (callback) yield callback();
            if (route) yield call(NavigationService.push, route);
        } else {
            yield put(CommunityActions.addcontenteventFailure());
        }
    } catch (e) {
        yield put(CommunityActions.addcontenteventFailure());
    }
}

export function* getcommunityblogRequest(api, action) {
    try {
        const { payload } = action;
        const loginUser = yield select((state) => state.app.user?.community_user);

        if (!payload?.userId) payload.userId = loginUser?.id;
        const { slug, ...others } = payload;
        const options = queryString.stringify(decamelize({ ...others }));

        const response = yield api.getCommunityBlog(options);
        if (response.ok) {
            yield put(
                CommunityActions.getcommunityblogSuccess({
                    ...response.data,
                    user_id: payload?.userId,
                    slug: slug ?? loginUser?.entity?.slug,
                })
            );
        } else {
            yield put(CommunityActions.getcommunityblogFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getcommunityblogFailure());
    }
}

export function* getcommunityuserRequest(api, action) {
    try {
        const appUser = yield select((state) => state.app.user?.community_user);
        const { payload, callback, route, after } = action;
        const { userId, blogId } = payload;
        const options = blogId ? `blog_id=${blogId}` : `user_id=${userId}`;
        const resBlog = yield api.getBlogSummary(options);
        const response = appUser?.id === userId ? yield api.getCommunityUser(userId) : yield api.getCommunityUserView(userId);
        if (response.ok) {
            const { full_user, user } = response.data;
            const { entity } = user;
            yield put(
                CommunityActions.getcommunityuserSuccess({
                    user_id: userId,
                    entity: { ...entity, user: { ...full_user, ...user } },
                })
            );
            // Blogs data will be fetch and update in background
            const data = {
                ...resBlog.data,
                entity: { ...resBlog.data?.entity, user: { ...full_user, ...user } },
                user_id: userId,
            };
            yield put(CommunityActions.getcommunityuserSuccess(data));

            if (after) yield put({ ...after });
            if (route) yield call(NavigationService.push, route);
            if (callback) yield callback();
            if (resBlog.ok && resBlog.data?.has_blog) {
                const token = yield select((state) => state.app.token);
                const resBlogPosts = token ? yield api.getBlogDetail(`blog_id=${resBlog.data?.blog?.id}`) : yield api.getBlogPosts(`blog_id=${resBlog.data?.blog?.id}`);
                if (resBlogPosts.ok) {
                    const userData = token
                        ? {
                              ...data,
                              admins: resBlogPosts.data?.admins,
                              appends: resBlogPosts.data?.appends,
                              blog: resBlogPosts.data?.blog,
                              can_edit_blog: resBlogPosts.data?.can_edit_blog,
                              drafts: resBlogPosts.data?.drafts,
                              has_blog: resBlogPosts.data?.has_blog,
                              posts: resBlogPosts.data?.posts,
                          }
                        : {
                              ...data,
                              posts: resBlogPosts.data?.posts,
                          };
                    yield put(CommunityActions.getcommunityuserSuccess(userData));
                }
            }
        } else {
            yield put(CommunityActions.getcommunityuserFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getcommunityuserFailure());
    }
}

export function* getblogsummaryRequest(api, action) {
    try {
        const { userId, callback, route, after } = action.payload;
        const options = `user_id=${userId}`;
        const response = yield api.getBlogSummary(options);
        if (response.ok) {
            const data = { ...response.data, user_id: userId };
            yield put(CommunityActions.getblogsummarySuccess(data));
            if (after) yield put({ ...after });
            if (route) yield call(NavigationService.push, route);
            if (callback) yield callback();
        } else {
            yield put(CommunityActions.getblogsummaryFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getblogsummaryFailure());
    }
}

export function* getblogdetailsRequest(api, action) {
    try {
        const { userId, payload, callback, route, after } = action;
        const options = queryString.stringify(decamelize(payload), { arrayFormat: 'bracket' });
        const response = yield api.getBlogDetail(options);
        if (response.ok) {
            const data = { user_id: userId, ...(response.data ?? {}) };
            yield put(CommunityActions.getblogdetailsSuccess(data));
            if (after) yield put({ ...after });
            if (route) yield call(NavigationService.push, route);
            if (callback) yield callback();
        } else {
            yield put(CommunityActions.getblogdetailsFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getblogdetailsFailure());
    }
}

export function* getcommunityconnectionsRequest(api, action) {
    try {
        const { payload } = action;
        const options = queryString.stringify(payload);
        const response = yield api.getEntityConnections(options);
        if (response.ok) {
            yield put(CommunityActions.getcommunityconnectionsSuccess({ userId: payload.user_id, connections: response.data }));
        } else {
            yield put(CommunityActions.getcommunityconnectionsFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getcommunityconnectionsFailure());
    }
}

export function* postcommunityconnectRequest(api, action) {
    try {
        const { payload, route, after, callback } = action;
        const response = yield api.postEntityConnection(payload);
        if (response.ok) {
            yield put(CommunityActions.postcommunityconnectSuccess());
            if (after) yield put({ ...after });
            if (route) yield call(NavigationService.push, route);
            if (callback) yield callback();
        } else {
            yield put(CommunityActions.postcommunityconnectFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postcommunityconnectFailure());
    }
}

export function* getuserpermissionsRequest(api, action) {
    try {
        const { userId } = action.payload;
        const response = yield api.getUserPermissions(userId);
        if (response.ok) {
            yield put(CommunityActions.getuserpermissionsSuccess({ userId, permissions: response.data }));
        } else {
            yield put(CommunityActions.getuserpermissionsFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getuserpermissionsFailure());
    }
}

export function* postcommunityuserRequest(api, action) {
    const { data, callback, route, after } = action.payload;
    const response = yield api.postCommunityUser(data);

    if (response.ok) {
        if (after) yield put({ ...after });
        if (route) yield call(NavigationService.push, route);
        if (callback) yield callback();
        yield put(CommunityActions.postcommunityuserSuccess());
        yield put(AppActions.posteditprofileSuccess(response.data.user));
    } else {
        yield put(CommunityActions.postcommunityuserFailure());
    }
}

export function* postsaveusercontentRequest(api, action) {
    const { data, callback, route, after } = action.payload;
    const response = yield api.postSaveUserContent(data);

    if (response.ok) {
        if (after) yield put({ ...after });
        if (route) yield call(NavigationService.push, route);
        if (callback) yield callback();
        yield put(CommunityActions.postsaveusercontentSuccess());
    } else {
        yield put(CommunityActions.postsaveusercontentFailure());
    }
}

export function* postpasswordchangeRequest(api, action) {
    try {
        const { userId, verfiyPassword, changePassword } = action.payload;
        const response = yield api.postCheckPassword(verfiyPassword);

        if (response.ok && response.data.status === 'success') {
            yield put(AppActions.posteditprofileRequest(userId, changePassword));
            toast.success('Your Password has be updated Successfully', {
                position: toast.POSITION.CENTRE_RIGHT,
            });
            yield put(CommunityActions.postpasswordchangeSuccess());
        } else {
            toast.error('Oops, Your current password is incorrect! ', {
                position: toast.POSITION.TOP_RIGHT,
            });
            yield put(CommunityActions.postpasswordchangeFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postpasswordchangeFailure());
    }
}

export function* postunfollowRequest(api, action) {
    try {
        const { data, after } = action.payload;
        const response = yield api.postUnfollowRequest(data);
        if (response.ok && response.data.status === 'success') {
            if (after) yield put({ ...after });
            yield put(CommunityActions.postunfollowSuccess());
        } else {
            yield put(CommunityActions.postunfollowFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postunfollowFailure());
    }
}

export function* postconnectionupdateRequest(api, action) {
    try {
        const { data, after } = action.payload;
        const response = yield api.postConnectionUpdate(data);
        if (response.ok) {
            if (after) yield put({ ...after });
            yield put(CommunityActions.postconnectionupdateSuccess());
        } else {
            yield put(CommunityActions.postconnectionupdateFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postconnectionupdateFailure());
    }
}

export function* postregisteruserRequest(api, action) {
    try {
        const { payload, route, after } = action;
        const response = yield api.postRegisterUser(payload);

        if (response.ok) {
            yield put(AppActions.loginRequest({ email: payload.email, password: payload.password, rememberMe: true }, route, after));
            yield put(CommunityActions.postregisteruserSuccess());
        } else {
            toast.error(`Oops, ${response.data.message} `, {
                position: toast.POSITION.TOP_RIGHT,
            });
            yield put(AppActions.modalRequest({ type: '' }));
            yield put(CommunityActions.postregisteruserFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postregisteruserFailure());
    }
}

export function* gettopicsRequest(api, action) {
    try {
        const { payload } = action;
        const options = queryString.stringify(payload);
        const response = yield api.getGetTopics(options);

        if (response.ok) {
            yield put(CommunityActions.gettopicsSuccess(payload.category_id || 'all', response.data));
        } else {
            yield put(CommunityActions.gettopicsFailure());
        }
    } catch (e) {
        yield put(CommunityActions.gettopicsFailure());
    }
}

export function* getalldepartmentforumtopicsRequest(api, action) {
    try {
        const response = yield api.getAllDepartmentTopics();

        if (response.ok) {
            yield put(CommunityActions.getalldepartmentforumtopicsSuccess(response.data.categories));
        } else {
            yield put(CommunityActions.getalldepartmentforumtopicsFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getalldepartmentforumtopicsFailure());
    }
}

export function* getcomblogpostsRequest(api, action) {
    try {
        const { payload, target } = action;
        const options = queryString.stringify(decamelize(payload), { arrayFormat: 'bracket' });
        const response = yield api.getBlogPosts(options);

        if (response.ok) {
            yield put(CommunityActions.getcomblogpostsSuccess(response.data, target));
            const businesies = yield select((state) => state.company.business);
            const bns = clone(businesies);
            for (let business of bns) {
                if (business.vrs?.blog?.id === payload.blogId) {
                    business.vrs.blog.data = {
                        ...business.vrs.blog.data,
                        ...response.data,
                    };
                }
            }
            yield put(CompanyActions.getbusinessSuccess(bns));
        } else {
            yield put(CommunityActions.getcomblogpostsFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getcomblogpostsFailure());
    }
}

export function* geteditfeatureditemsRequest(api, action) {
    try {
        const { target = 'post', payload } = action;
        const options = queryString.stringify(payload);
        const response = yield api.getEditFeaturedItems(target, options);

        if (response.ok) {
            yield put(CommunityActions.geteditfeatureditemsSuccess(response.data.featured));
            if (after) yield put({ ...after });
        } else {
            yield put(CommunityActions.geteditfeatureditemsFailure());
        }
    } catch (e) {
        yield put(CommunityActions.geteditfeatureditemsFailure());
    }
}

export function* getfeatureditemsRequest(api, action) {
    try {
        const { target = 'post', payload } = action;
        const options = queryString.stringify(payload);
        const response = yield api.getFeaturedItems(target, options);
        if (response.ok) {
            yield put(CommunityActions.getfeatureditemsSuccess(response.data.featured));
        } else {
            yield put(CommunityActions.getfeatureditemsFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getfeatureditemsFailure());
    }
}

export function* postsavefeatureditemRequest(api, action) {
    try {
        const { target, payload, after } = action;
        const response = yield api.postSaveFeaturedItem(target, payload);
        if (response.ok) {
            toast.success(`Add Featured item successfully`, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(CommunityActions.postsavefeatureditemSuccess(response.data));
            if (after) yield put({ ...after });
        } else {
            yield put(CommunityActions.postsavefeatureditemFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postsavefeatureditemFailure());
    }
}

export function* postarchivefeatureditemRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.postArchiveFeaturedItem(payload);
        if (response.ok) {
            toast.success(`Archive Featured item successfully`, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(CommunityActions.postsavefeatureditemSuccess(response.data));
        } else {
            yield put(CommunityActions.postsavefeatureditemFailure());
        }
    } catch (e) {
        yield put(CommunityActions.postsavefeatureditemFailure());
    }
}

export function* getfeaturedcategoriesRequest(api, action) {
    try {
        const { payload } = action;
        const options = queryString.stringify(payload);
        const response = yield api.getFeaturedItems('vr_category', options);

        if (response.ok) {
            yield put(CommunityActions.getfeaturedcategoriesSuccess(response.data.categories));
        } else {
            yield put(CommunityActions.getfeaturedcategoriesFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getfeaturedcategoriesFailure());
    }
}

export function* getcategorysponsoredproductsRequest(api, action) {
    try {
        const { categoryId } = action;
        const response = yield api.getCategorySponsoredProducts(categoryId);

        if (response.ok) {
            yield put(CommunityActions.getcategorysponsoredproductsSuccess(categoryId, response.data.data));
        } else {
            yield put(CommunityActions.getcategorysponsoredproductsFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getcategorysponsoredproductsFailure());
    }
}

export function* deleteforumtopicRequest(api, action) {
    try {
        const { payload, callback } = action;
        const response = yield api.postDeleteForumTopic(payload);

        if (response.ok) {
            if (callback) yield callback();
            yield put(CommunityActions.deleteforumtopicSuccess());
            toast.success('Forum Deleted Successfully', {
                position: toast.POSITION.CENTRE_RIGHT,
            });
        } else {
            toast.error('Oops, forum deletion failed', {
                position: toast.POSITION.CENTRE_RIGHT,
            });
            yield put(CommunityActions.deleteforumtopicFailure());
        }
    } catch (e) {
        yield put(CommunityActions.deleteforumtopicFailure());
    }
}

export function* featuredpostsRequest(api, action) {
    try {
        const { url } = action;
        const params = split('/', url);
        const slug = params[3] === 'in' ? params[4] : params[3];
        const post = params[5];
        const response = yield api.getCompanySlug(slug);
        const data = response.data;
        if (response.ok) {
            yield call(NavigationService.push, `/${slug}/blog/${post}`);
            yield put(CommunityActions.featuredpostsSuccess());
        } else {
            if (url && url !== '') {
                const path = startsWith('http', url) ? url : `https://${url}`;
                window.open(path, '_blank');
            }
            yield put(CommunityActions.featuredpostsFailure());
        }
    } catch (e) {
        const { url } = action;
        if (url && url !== '') {
            const path = startsWith('http', url) ? url : `https://${url}`;
            window.open(path, '_blank');
        }
        yield put(CommunityActions.featuredpostsFailure());
    }
}

export function* getemployersearchRequest(api, action) {
    try {
        const { payload } = action;
        const options = queryString.stringify(decamelize(payload));

        const response = yield api.getEmployerSearch(options);
        if (response.ok) {
            yield put(CommunityActions.getemployersearchSuccess(response.data));
        } else {
            yield put(CommunityActions.getemployersearchFailure());
        }
    } catch (e) {
        yield put(CommunityActions.getemployersearchFailure());
    }
}
